import {
  IS_LOGIN,
  AUTH_LOADING,
  AUTH_ERROR,
  SET_USER,
  VERIFY_TOKEN,
} from "../actions/type";

// A function, not a snapshot: DESTROY_SESSION resets the store to undefined,
// and a value captured at module load would restore isLogin: true after a
// logout that had just cleared the token.
const initialState = () => ({
  // Rehydrated from localStorage so a refresh keeps the session.
  isLogin: Boolean(localStorage.getItem("authToken")),
  user: null,
  loading: false,
  error: "",
  verifyToken: {},
});

export default function authReducer(state, action) {
  if (state === undefined) state = initialState();

  const { type, payload } = action;

  switch (type) {
    case IS_LOGIN:
      return {
        ...state,
        isLogin: payload,
      };
    case SET_USER:
      return {
        ...state,
        user: payload,
      };
    case AUTH_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case AUTH_ERROR:
      return {
        ...state,
        error: payload,
      };
    case VERIFY_TOKEN:
      return {
        ...state,
        verifyToken: payload,
      };
    default:
      return state;
  }
}
